var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},React.createElement("path",{"d":"M0 0H32V2H0zM0 10H32V12H0zM0 20H32V22H0z"})));
}

BurgerMenu.defaultProps = {"width":"32","height":"22","viewBox":"0 0 32 22"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
